<template>
  <div id="Content">
    <div class="content-inner sale-links-page">
      <div class="page-header">
        <h2 v-if="userName" class="welcome-message">Welcome, {{ userName }}</h2>
        <!-- <h4 class="page-subtitle">Sale Links</h4> -->
        <p class="page-description">
          This page will show all the sale links that have been created for your
          products. Please bookmark this page, as it will allow you to easily
          access and share your referral links.
        </p>
      </div>

      <div
        v-for="(category, catIndex) in productLinks"
        :key="catIndex"
        class="table-container"
      >
        <div class="category-header">{{ category.category }}</div>
        <table class="sale-links-table">
          <thead>
            <tr>
              <th>Products</th>
              <th>Link</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(link, index) in category.links" :key="index">
              <td class="event-name">
                <span class="product-name">{{ link.name }}</span>
                <span v-if="link.price" class="product-price">
                  {{ link.price }}
                </span>
              </td>
              <td class="link-cell">
                <a
                  :href="getFullLink(link.link)"
                  target="_blank"
                  class="link-text"
                >
                  {{ getFullLink(link.link) }}
                </a>
              </td>
              <td class="action-cell">
                <button
                  class="btn-copy"
                  @click="copyLink(getFullLink(link.link))"
                >
                  Copy Link
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "sale-links",
  data() {
    return {
      productLinks: [],
      refCode: null,
      userName: null
    };
  },
  created() {
    this.parseQueryParams();
    this.fetchSaleLinks();
  },
  methods: {
    async fetchSaleLinks() {
      // TODO: Replace with actual API call
      // const response = await this.$http.get('/api/sale-links');
      // this.productLinks = response.data;

      this.productLinks = [
        {
          category: "Go Pro Certification",
          links: [
            {
              name: "Go Pro Certification",
              link:
                "https://tw126.infusionsoft.app/app/orderForms/Go-Pro-Certification",
              price: "$4,997.00"
            },
            {
              name: "Go Pro Certification w deposit",
              link:
                "https://tw126.infusionsoft.com/app/orderForms/Go-Pro-Certification-w-deposit",
              price: "$4,997.00"
            },
            {
              name: "Go Pro Certification 3pay",
              link:
                "https://tw126.infusionsoft.com/app/orderForms/Go-Pro-Certification-3pay",
              price: "$5,691.00"
            },
            {
              name: "Go Pro Certification 6pay",
              link:
                "https://tw126.infusionsoft.com/app/orderForms/Go-Pro-Certification-6pay",
              price: "$5,982.00"
            },
            {
              name: "Go Pro Certification 11pay",
              link:
                "https://tw126.infusionsoft.com/app/orderForms/Go-Pro-Certification-11pay",
              price: "$6,347.00"
            }
          ]
        },
        {
          category: "Go Pro Certification and Mentorship",
          links: [
            {
              name: "Go Pro Certification Mentorship",
              link:
                "https://tw126.infusionsoft.com/app/orderForms/Go-Pro-Certification-Mentorship",
              price: "$7,497.00"
            },
            {
              name: "Go Pro Certification Mentorship w deposit",
              link:
                "https://tw126.infusionsoft.com/app/orderForms/Go-Pro-Certification-Mentoship-wdeposit",
              price: "$7,497.00"
            },
            {
              name: "Go Pro Certification and Mentorship 3pay",
              link:
                "https://tw126.infusionsoft.com/app/orderForms/Go-Pro-Certification-and-Mentorship-3pay",
              price: "$8,250.00"
            },
            {
              name: "Go Pro Certification and Mentorship 6pay",
              link:
                "https://tw126.infusionsoft.com/app/orderForms/Go-Pro-Certification-and-Mentorship-6pay",
              price: "$8,982.00"
            },
            {
              name: "Go Pro Certification and Mentorship 11pay",
              link:
                "https://tw126.infusionsoft.com/app/orderForms/Go-Pro-Certification-and-Mentorship---11pay",
              price: "$9,317.00"
            },
            {
              name: "Go Pro Certification and Mentorship Partner Program",
              link:
                "https://tw126.infusionsoft.com/app/orderForms/Go-Pro-Certification-and-Mentorship--partner-program",
              price: "$750.00"
            },
            {
              name: "Certification to Mentorship Upgrade",
              link:
                "https://tw126.infusionsoft.com/app/orderForms/certification-to-mentorship-upgrade",
              price: "$2,500.00"
            }
          ]
        },
        {
          category: "Leadership Labs Certification",
          links: [
            {
              name: "Leadership Labs Certification",
              link:
                "https://tw126.infusionsoft.com/app/orderForms/Leadership-Labs-Certification",
              price: "$1,997.00"
            },
            {
              name: "Leadership Labs Certification w deposit",
              link:
                "https://tw126.infusionsoft.com/app/orderForms/Leadership-Labs-Certification-wdeposit",
              price: "$1,997.00"
            },
            {
              name: "Leadership Labs Certification 3pay",
              link:
                "https://tw126.infusionsoft.com/app/orderForms/Leadership-Labs-Certification-3pay",
              price: "$2,275.00"
            },
            {
              name: "Leadership Labs Certification 6pay",
              link:
                "https://tw126.infusionsoft.com/app/orderForms/Leadership-Labs-Certification-6pay",
              price: "$2,310.00"
            }
          ]
        },
        {
          category: "Leadership Labs Certification and Mentorship",
          links: [
            {
              name: "Leadership Labs Certification and Mentorship",
              link:
                "https://tw126.infusionsoft.com/app/orderForms/Leadership-Labs-Certification-and-Mentorship",
              price: "$2,997.00"
            },
            {
              name: "Leadership Labs Certification and Mentorship w deposit",
              link:
                "https://tw126.infusionsoft.com/app/orderForms/Leadership-Labs-Certification-and-Mentorship-wdeposit",
              price: "$2,997.00"
            },
            {
              name: "Leadership Labs Certification and Mentorship 3pay",
              link:
                "https://tw126.infusionsoft.com/app/orderForms/Leadership-Labs-Certification-and-Mentorship-3pay",
              price: "$3,300.00"
            },
            {
              name: "Leadership Labs Certification and Mentorship 6pay",
              link:
                "https://tw126.infusionsoft.com/app/orderForms/Leadership-Labs-Certification-and-Mentorship-6pay",
              price: "$3,540.00"
            },
            {
              name: "Leadership Labs Mentoring Upgrade",
              link:
                "https://tw126.infusionsoft.com/app/orderForms/Leadership-Labs-Mentoring-Upgrade",
              price: "$2,500.00"
            }
          ]
        }
      ];

      // [
      //   {
      //     category: "Go Pro Certification",
      //     links: [
      //       {
      //         name: "Go Pro Certification",
      //         link:
      //           "https://tw126.infusionsoft.app/app/orderForms/Go-Pro-Certification",
      //         price: "$49.99"
      //       },
      //       {
      //         name: "Go Pro Certification w deposit",
      //         link:
      //           "https://tw126.infusionsoft.com/app/orderForms/Go-Pro-Certification-w-deposit"
      //       },
      //       {
      //         name: "Go Pro Certification 3pay",
      //         link:
      //           "https://tw126.infusionsoft.com/app/orderForms/Go-Pro-Certification-3pay"
      //       },
      //       {
      //         name: "Go Pro Certification 6pay",
      //         link:
      //           "https://tw126.infusionsoft.com/app/orderForms/Go-Pro-Certification-6pay"
      //       },
      //       {
      //         name: "Go Pro Certification 11pay",
      //         link:
      //           "https://tw126.infusionsoft.com/app/orderForms/Go-Pro-Certification-11pay"
      //       }
      //     ]
      //   },
      //   {
      //     category: "Go Pro Certification and Mentorship",
      //     links: [
      //       {
      //         name: "Go Pro Certification Mentorship",
      //         link:
      //           "https://tw126.infusionsoft.com/app/orderForms/Go-Pro-Certification-Mentorship"
      //       },
      //       {
      //         name: "Go Pro Certification Mentorship w deposit",
      //         link:
      //           "https://tw126.infusionsoft.com/app/orderForms/Go-Pro-Certification-Mentoship-wdeposit"
      //       },
      //       {
      //         name: "Go Pro Certification and Mentorship 3pay",
      //         link:
      //           "https://tw126.infusionsoft.com/app/orderForms/Go-Pro-Certification-and-Mentorship-3pay"
      //       },
      //       {
      //         name: "Go Pro Certification and Mentorship 6pay",
      //         link:
      //           "https://tw126.infusionsoft.co  m/app/orderForms/Go-Pro-Certification-and-Mentorship-6pay"
      //       },
      //       {
      //         name: "Go Pro Certification and Mentorship 11pay",
      //         link:
      //           "https://tw126.infusionsoft.com/app/orderForms/Go-Pro-Certification-and-Mentorship---11pay"
      //       },
      //       {
      //         name: "Go Pro Certification and Mentorship Partner Program",
      //         link:
      //           "https://tw126.infusionsoft.com/app/orderForms/Go-Pro-Certification-and-Mentorship--partner-program"
      //       },
      //       {
      //         name: "Certification to Mentorship Upgrade",
      //         link:
      //           "https://tw126.infusionsoft.com/app/orderForms/certification-to-mentorship-upgrade"
      //       }
      //     ]
      //   },
      //   {
      //     category: "Leadership Labs Certification",
      //     links: [
      //       {
      //         name: "Leadership Labs Certification",
      //         link:
      //           "https://tw126.infusionsoft.com/app/orderForms/Leadership-Labs-Certification"
      //       },
      //       {
      //         name: "Leadership Labs Certification w deposit",
      //         link:
      //           "https://tw126.infusionsoft.com/app/orderForms/Leadership-Labs-Certification-wdeposit"
      //       },
      //       {
      //         name: "Leadership Labs Certification 3pay",
      //         link:
      //           "https://tw126.infusionsoft.com/app/orderForms/Leadership-Labs-Certification-3pay"
      //       },
      //       {
      //         name: "Leadership Labs Certification 6pay",
      //         link:
      //           "https://tw126.infusionsoft.com/app/orderForms/Leadership-Labs-Certification-6pay"
      //       }
      //     ]
      //   },
      //   {
      //     category: "Leadership Labs Certification and Mentorship",
      //     links: [
      //       {
      //         name: "Leadership Labs Certification and Mentorship",
      //         link:
      //           "https://tw126.infusionsoft.com/app/orderForms/Leadership-Labs-Certification-and-Mentorship"
      //       },
      //       {
      //         name: "Leadership Labs Certification and Mentorship w deposit",
      //         link:
      //           "https://tw126.infusionsoft.com/app/orderForms/Leadership-Labs-Certification-and-Mentorship-wdeposit"
      //       },
      //       {
      //         name: "Leadership Labs Certification and Mentorship 3pay",
      //         link:
      //           "https://tw126.infusionsoft.com/app/orderForms/Leadership-Labs-Certification-and-Mentorship-3pay"
      //       },
      //       {
      //         name: "Leadership Labs Certification and Mentorship 6pay",
      //         link:
      //           "https://tw126.infusionsoft.com/app/orderForms/Leadership-Labs-Certification-and-Mentorship-6pay"
      //       },
      //       {
      //         name: "Leadership Labs Mentoring Upgrade",
      //         link:
      //           "https://tw126.infusionsoft.com/app/orderForms/Leadership-Labs-Mentoring-Upgrade"
      //       }
      //     ]
      //   }
      // ];
    },
    copyLink(link) {
      navigator.clipboard.writeText(link);
      alert("Link copied to clipboard!");
    },
    parseQueryParams() {
      const urlParams = new URLSearchParams(window.location.search);
      this.refCode = urlParams.get("ref");
      this.userName = urlParams.get("name");
    },
    getFullLink(link) {
      if (!this.refCode) return link;
      const separator = link.includes("?") ? "&" : "?";
      return `${link}${separator}ref=${this.refCode}`;
    }
  }
};
</script>

<style scoped>
p {
  font-size: 16px;
}
.sale-links-page {
  padding: 24px;
}

.page-header {
  margin-bottom: 24px;
}

.welcome-message {
  font-size: 20px;
  color: #e0e0e0;
  margin-bottom: 8px;
}

.page-header h2 {
  font-size: 28px;
  font-weight: 600;
  color: var(--primary-orange);
  margin-bottom: 8px;
}

.page-description {
  font-size: 16px;
  color: #a0a0a0;
  margin: 0;
}

.table-container {
  background: #2a2a2a;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  margin-bottom: 24px;
}

.category-header {
  background: var(--primary-orange);
  color: #1a1a1a;
  padding: 14px 16px;
  font-size: 18px;
  font-weight: 600;
}

.sale-links-table {
  width: 100%;
  border-collapse: collapse;
}

.sale-links-table thead {
  background: #333;
}

.sale-links-table th {
  padding: 16px;
  text-align: left;
  font-weight: 600;
  color: var(--primary-orange);
  border-bottom: 2px solid rgba(207, 181, 149, 0.3);
}

.sale-links-table td {
  padding: 16px;
  border-bottom: 1px solid #3a3a3a;
  vertical-align: middle;
}

.sale-links-table tbody tr:hover {
  background: rgba(207, 181, 149, 0.1);
}

.sale-links-table tbody tr:last-child td {
  border-bottom: none;
}

.event-name {
  font-weight: 500;
  color: #e0e0e0;
  max-width: 180px;
  word-break: break-word;
  white-space: normal;
}

.product-name {
  display: block;
  line-height: 1.4;
}

.product-price {
  display: block;
  margin-top: 4px;
  color: var(--primary-orange);
  font-weight: 600;
  font-size: 14px;
}

.link-cell {
  max-width: 400px;
}

.link-text {
  color: var(--primary-orange);
  text-decoration: none;
  word-break: break-all;
  font-size: 16px;
}

.link-text:hover {
  text-decoration: underline;
  opacity: 0.8;
}

.action-cell {
  width: 120px;
}

.btn-copy {
  background: var(--primary-orange);
  color: #1a1a1a;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: opacity 0.2s, transform 0.2s;
}

.btn-copy:hover {
  opacity: 0.85;
  transform: translateY(-1px);
}
</style>